import { render, staticRenderFns } from "./WxWorkMsg.vue?vue&type=template&id=35e0e05c&scoped=true&"
import script from "./WxWorkMsg.vue?vue&type=script&lang=js&"
export * from "./WxWorkMsg.vue?vue&type=script&lang=js&"
import style0 from "./WxWorkMsg.vue?vue&type=style&index=0&id=35e0e05c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e0e05c",
  null
  
)

export default component.exports